import { useNavigate } from 'react-router-dom';

import { CalendarMeetingInfoDto, CalendarMeetingInfoDtoType } from '@/api/generated';
import { RAW_ROUTES } from '@/enums/RoutesMap';

export const onMeetingClick = (
  meeting: CalendarMeetingInfoDto,
  navigate: ReturnType<typeof useNavigate>
) => {
  if (!meeting.type) return;
  if (meeting.type === CalendarMeetingInfoDtoType.myMeeting && meeting.id)
    navigate(`${RAW_ROUTES.Meeting}${meeting.id}`);
  else if (meeting.type === CalendarMeetingInfoDtoType.publicShared && meeting.sharedMeetingId)
    navigate(`${RAW_ROUTES.SharedPublicMeeting}${meeting.sharedMeetingId}`);
  else if (meeting.type === CalendarMeetingInfoDtoType.privateShared && meeting.sharedMeetingId)
    navigate(`${RAW_ROUTES.SharedMeeting}${meeting.sharedMeetingId}`);
};
